import React from 'react';
import { ReactComponent as FileText } from 'App/assets/img/file-text.svg';
import { AnchorLink, Container } from './Certified.styles';

export const Certified = ({ path }: { path: string }) => {
	return (
		<Container certified={!!path}>
			<FileText width="19px" height="19px" />
			<AnchorLink
				certified={!!path}
				href={path}
				download
				data-testid="download-certified-button"
				target="_blank"
				rel="noreferrer"
				role="button"
				aria-pressed="false"
				tabIndex={0}
			>
				Certificado
			</AnchorLink>
		</Container>
	);
};
